export default __webpack_public_path__ + "98eb0030fac40c95fc07d1ad2ee7a3e6.jpg";